import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class TollReviewStatus extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}

